import * as moment from 'moment';
import {Cloneable, DayType, ResultWithNumberIds, ScheduleType, SexType} from './common.model';
import {JSonSerializer} from './JSonSerializer';
import {Utils} from "./Utils";
import {DisplayInterval} from "../directives/displayInterval";

import {DateEncoding} from "./DateEncoding";
import {PlanningDetail} from "../home/planning/model/Planning";
import {DisplayMinute} from "../directives/display.minute";
import {EmployeeTimedTaskParams} from "../home/task/model/EmployeeTimedTaskParams";

import {BankTypeEmployeHoraire} from "../home/bank/model/BankTypeEmployeHoraire";


export class Meal {
  start: Date;
  end: Date;
  paid = false;

  get empty(): boolean {
    if (!Utils.isNullOrUndefined(this.start) && !Utils.isNullOrUndefined(this.end) ) {
      return false;
    }else {
      return true;
    }
  }
}

// Schedule part of EMPLOYE_HORAIRE
export class EmployeeSchedule extends Cloneable {
    id: number = -1 * moment().unix();
    employee = new EmployeeInfo();
    wage: number;
    refDate: Date;
    interval: number;
    intervalOverNight: number;
    startHour: Date;
    endHour: Date;
    type = ScheduleType.TRAVAIL ;
    employeeId: string; // Careful maybe empty
    jobId: string;
    unitId: string;
    meal1: Meal = new Meal();
    meal2: Meal = new Meal();
    break1: Date;
    break2: Date;
    note: string;
    active = false; // publish - unpublish
    template = false;
    sdDefaultBg: number;
    task1: string;
    task2: string;
    task3: string;
    task4: string;
    task5: string;
    task6: string;
    task7: string;
    task8: string;
    task9: string;
    task10: string;
    function: string;
    lastScheduleChangeDt: Date;
    lastScheduleChangeByEmployeeId: string;
    lastScheduleChangeByEmployee: string;

    //TimedTasksAddedToThisSpecific EmployeeHoraire.
    timedTasksParams = new Array<EmployeeTimedTaskParams>();
    lastTimeSeenByEmployee: Date;

    readOnly  = false;
    readOnlyNote: string;
    timesheetApproved = false;


    private _bankTypeEmployeHoraire : BankTypeEmployeHoraire;

  //  planDetailId = 0; // Associate to planDetail If any.

    private _justPublished = false;
    private _justUnpublished = false;
    private _deleting = false;

    private _modified = false;
    private _toValidate = true;

    public set BankTypeEmployeHoraire(bean: BankTypeEmployeHoraire){
      this._bankTypeEmployeHoraire = bean;
      console.log('added BankTypeEmployeHoraire to ' + this.refDate );

    }

    public get BankTypeEmployeHoraire(){
      return this._bankTypeEmployeHoraire;
    }


   public set modified(b: boolean){
      this._modified = b;
      if (this._modified === true){
        this._toValidate = true;
      }
    }

    public set toValidate(b: boolean){
      this._toValidate = b;
    }


    public get toValidate(){
      return this._toValidate;
    }

    public get modified(){
      return this._modified;
    }

    constructor () {
      super();
      this.resetId();
    }

    get deleting(){
      return this._deleting;
    }
    set deleting(b:boolean){
      this._deleting = b;
    }

  /**
   * When a EmployeeHoraire is new and not saved yet, its id is < 0
   * After saving, we are receiving the list of new ids, we are synchronizing them.
   */
  syncId(ids: ResultWithNumberIds){
      if (Utils.isDefined(ids)){
        for (const bean of ids.saved){
          if (bean.old === this.id){
            this.id = bean.current;
            return true;
          }
        }
      }

      return false;
    }



  resetId(){
      this.id = -1 * Math.floor(Math.random() * Number.MAX_SAFE_INTEGER);
    }

    _createSpecialElement(propertyName: string, data: any) {
      if ('type' === propertyName) {
        this.type = ScheduleType.retrieveFromCode(data);
        return true;
      }
      return false;
    }


    _createFromArray(propertyName: string, data: any) {
      const serializer = new JSonSerializer();
      if ('timedTasksParams' === propertyName) {
        for (const bean of data) {
          const tmp = new EmployeeTimedTaskParams();
           serializer.deserialize(bean, tmp);
          this.timedTasksParams.push(bean);
        }
      }
    }


  /**
     * Format is 08:00 - 14:00, Task 1
     */
    readTaskToRetrieveStartEndTime(task: string,dm: DisplayMinute, ampm: boolean):{label:string, startHour:Date,endHour: Date}{
       const res =  {label: null, startHour:null,endHour:null};
       const idx = task.indexOf(',');
       if (idx>=0){
         const hour = task.substr(0,idx);
         if (hour){
           const idxStart = hour.indexOf('-');
           if (idxStart>=0){
             res.startHour = dm.retrieveAsDate(hour.substr(0,idxStart),ampm);
             res.endHour = dm.retrieveAsDate(hour.substr(idxStart+1),ampm);
           }
           res.label = task.substr(idx+1);
           if (res.label){
             res.label = res.label.trim();
           }
         }
       }
      return res;
    }

  getDayOfWeek(): number {
      if (this.refDate) {
        return Number(moment(this.refDate).format('d'));
      }else {
        return -1;
      }
    }

    calcDelayInMin(): number {
      if (ScheduleType.CONGE_SANS_SOLDE === this.type){
        return 0;
      }
      if (ScheduleType.VACANCE === this.type){
        return 0;
      }
      if (ScheduleType.FERIE === this.type){
        return 0;
      }

      // if (ScheduleType.BANK_TYPE === this.type) {
        if (this._bankTypeEmployeHoraire) {
          return this._bankTypeEmployeHoraire.valueInMinutes;
        }
      //}
      return this.calcDelayInMinWithoutCheckingScheduleType();
    }


  calcDelayInMinWithoutCheckingScheduleType(): number {
    if ((!this.startHour) || (!this.endHour) ) {
      return 0;
    }




    // const start = moment(this.startHour);
    // const end = moment(this.endHour);
    // const diffInSec = end.unix() - start.unix();
    // const de = new DateEncoding();
//    if (!de.isOvernightWithDate(this.startHour,this.endHour)){
    let diffInMin = Utils.diffDateInMinutes(this.startHour,this.endHour);
    // console.log('delay ' + diffInMin);
    // if (de.isMidnight(this.endHour) && Utils.sameDay(this.startHour,this.endHour)){
    //
    //
    //
    // }
    if (diffInMin<0){
      console.log('startHour: ' + this.startHour + ' endHour ' + this.endHour);
    }


    if (this.meal1 && (Utils.isNullOrUndefined(this.meal1.paid) || this.meal1.paid===false)){
      // console.log('meal1 delay ' + Utils.diffDateInMinutes(this.meal1.start,this.meal1.end) + ' ' + this.meal1.start + ' ' + this.meal1.end);
      diffInMin = diffInMin - Utils.diffDateInMinutes(this.meal1.start,this.meal1.end);
    }
    // console.log('after meal1 delay ' + diffInMin);
    if (this.meal2 && (Utils.isNullOrUndefined(this.meal2.paid) || this.meal2.paid===false)){
      diffInMin = diffInMin - Utils.diffDateInMinutes(this.meal2.start,this.meal2.end);
    }
    // console.log('after meal2 delay ' + diffInMin);
    return diffInMin;
    // return (diffInSec - diffInSec % 60) / 60;
  }


    calculateWage( durationInMinutes: number): number {

      // console.log('calculateWage');
      // if (ScheduleType.BANK_TYPE === this.type) {
        if (this._bankTypeEmployeHoraire) {
          // console.log('calculateWage with BankTypeEmployeHoraire');
          if (this._bankTypeEmployeHoraire.useNormalEmployeeRate===false){
            // console.log('calculateWage ' + this._bankTypeEmployeHoraire.hourlyWage);
            return durationInMinutes * this._bankTypeEmployeHoraire.hourlyWage / 60;
          }
        }
      // }
      return durationInMinutes * this.wage / 60;
    }

    public isActiveAtThisHour(hour:number):boolean{
        return Utils.isHourIncluded(hour,this.startHour,this.endHour);
    }


    public isActiveAtTheseHours(hours:number[]):boolean{
        return Utils.isAnyHourIncluded(hours,this.startHour,this.endHour);
    }

    get isNewOrModified(): boolean{
      // console.log('isNew Or Modified: ' + this.id + ' ' + this.modified);
        if (this.id < 0) {
          return true;
        }
        return this.modified;
    }

    public adjustRefDateWithStartAndEndHour() {
      if (this.refDate) {
          const m = moment(this.refDate);
          const start = moment(this.startHour);
          // this.startHour = moment().date(m.date()).month(m.month()).year(m.year()).hour(start.hour()).minute(start.minute()).second(0).millisecond(0).toDate();
          this.startHour = moment(this.refDate).startOf('day').hour(start.hour()).minute(start.minute()).toDate();
        // this.startHour = moment().date(m.date()).month(m.month()).year(m.year()).hour(start.hour()).minute(start.minute()).second(0).millisecond(0).toDate();
          const end = moment(this.endHour);
          const de = new DateEncoding();
          if (de.isOvernight({h:start.hour(),m:start.minute()},{h:end.hour(),m:end.minute()}) || (de.isMidnight(this.endHour))){
            console.log('Found overnight shift adding 1 day to the end hour.');
            this.endHour = moment(this.refDate).startOf('day').add(1,'day').hour(end.hour()).minute(end.minute()).toDate();
          }else{
            this.endHour = moment(this.refDate).startOf('day').hour(end.hour()).minute(end.minute()).toDate();
          }

          if (!Utils.isNullOrUndefined(this.meal1)){
            console.log('Adjusting Meal1',this.meal1)
            let tmp = moment(this.meal1.start);
            this.meal1.start = moment(this.refDate).startOf('day').hour(tmp.hour()).minute(tmp.minute()).toDate();
            tmp = moment(this.meal1.end);
            this.meal1.end = moment(this.refDate).startOf('day').hour(tmp.hour()).minute(tmp.minute()).toDate();
            console.log('Adjusted Meal1',this.meal1)
          }

          if (!Utils.isNullOrUndefined(this.meal2)){
            console.log('Adjusting Meal2')
            let tmp = moment(this.meal2.start);
            this.meal2.start = moment(this.refDate).startOf('day').hour(tmp.hour()).minute(tmp.minute()).toDate();
            tmp = moment(this.meal2.end);
            this.meal2.end = moment(this.refDate).startOf('day').hour(tmp.hour()).minute(tmp.minute()).toDate();
          }

          if (!Utils.isNullOrUndefined(this.break1)){
            let tmp = moment(this.break1);
            this.break1 = moment(this.refDate).startOf('day').hour(tmp.hour()).minute(tmp.minute()).toDate();
          }
          if (!Utils.isNullOrUndefined(this.break2)){
            let tmp = moment(this.break2);
            this.break2 = moment(this.refDate).startOf('day').hour(tmp.hour()).minute(tmp.minute()).toDate();
          }

         //this.adjustRefDateToFirstDateOfSchedule();

          // this.endHour = moment().date(m.date()).month(m.month()).year(m.year()).hour(end.hour()).minute(end.minute()).second(0).millisecond(0).toDate();
      }
    }

  /**
   * Not used. Trying to fix the problem with TZ on the Java Side
   */
  /*
  private adjustRefDateToFirstDateOfSchedule(){
      if (!Utils.isNullOrUndefined(this.startHour)){
        this.refDate = this.startHour;
      }else if (!Utils.isNullOrUndefined(this.endHour)){
        this.refDate = this.endHour;
      }
    }
  */

    public copyMealsBreaksAndTasks(pd:PlanningDetail){
      if (!Utils.isNullOrUndefined(pd.meal1StartHour) && pd.meal1DurationInMin>0){
        this.meal1 = new Meal();
        this.meal1.start = Utils.mixDateAndHourMinute(this.refDate,pd.meal1StartHour);
        this.meal1.end = moment(pd.meal1StartHour).add(pd.meal1DurationInMin,'minute').toDate();
        this.meal1.paid = pd.meal1Paid;
      }else{
        delete this.meal1;
      }
      if (!Utils.isNullOrUndefined(pd.meal2StartHour) && pd.meal2DurationInMin>0){
        this.meal2 = new Meal();
        this.meal2.start = Utils.mixDateAndHourMinute(this.refDate,pd.meal2StartHour);
        this.meal2.end = moment(pd.meal2StartHour).add(pd.meal2DurationInMin,'minute').toDate();
        this.meal2.paid = pd.meal2Paid;
      }else{
        delete this.meal2;
      }
      if (!Utils.isNullOrUndefined(pd.break1StartHour) && pd.break1DurationInMin>0){
        this.break1 = Utils.mixDateAndHourMinute(this.refDate,pd.break1StartHour);
      }
      if (!Utils.isNullOrUndefined(pd.break2StartHour) && pd.break2DurationInMin>0){
        this.break2 = Utils.mixDateAndHourMinute(this.refDate,pd.break2StartHour);
      }
      //Copy Tasks and Function
        this.function = pd.function;
        this.task1 = pd.task1;
        this.task2 = pd.task2;
        this.task3 = pd.task3;
        this.task4 = pd.task4;
        this.task5 = pd.task5;
        this.task6 = pd.task6;
        this.task7 = pd.task7;
        this.task8 = pd.task8;
        this.task9 = pd.task9;
        this.task10 = pd.task10;


    }

  public clone(): any {
      const res = super.clone();
      res.cloneMeals(this);
      return res;
  }

  public cloneMeals(es:EmployeeSchedule) {
    if (!Utils.isNullOrUndefined(es.meal1)) {
      this.meal1 = new Meal();
      this.meal1.start = Utils.mixDateAndHourMinute(this.refDate, es.meal1.start);
      this.meal1.end = Utils.mixDateAndHourMinute(this.refDate, es.meal1.end);
      this.meal1.paid = es.meal1.paid;
    } else {
      delete this.meal1;
    }
    if (!Utils.isNullOrUndefined(es.meal2)) {
      this.meal2 = new Meal();
      this.meal2.start = Utils.mixDateAndHourMinute(this.refDate, es.meal2.start);
      this.meal2.end = Utils.mixDateAndHourMinute(this.refDate, es.meal2.end);
      this.meal2.paid = es.meal2.paid;
    } else {
      delete this.meal2;
    }
  }

    public publish(){
       if (this.active !== true){
         console.log('publish it!');
         this.active = true;
         this._justPublished = true;
         this._justUnpublished = false;
         this.modified = true;
       }
    }


    public unPublish(){
      if (this.active){
        console.log('unPublish it!');
        // this.active = false;
        // this.active = true;
        this.active = false;
        this._justPublished = false;
        this._justUnpublished = true;
        this.modified = true;
      }
    }

    public syncDone(){
      // console.log('syncing');
      this._justPublished = false;
      this._justUnpublished = false;
      this.modified = false;
    }


  public get justUnpublished(): boolean{
      return this._justUnpublished;
  }
  public get justPublished(): boolean{
      return this._justPublished;
    }

    public debug(): string{
      let res = '';
      const di = new DisplayInterval(null);
      res += this.id + ', ' + this.employeeId + ', ' + this.jobId + ', ' + moment(this.refDate).format('LL') + ', ' + this.type + ' ' + di.displayDates(this.startHour,this.endHour,false);

      return res;
    }

  public get hasDetails():boolean{
    if (!Utils.isNullOrUndefined(this.meal1)){
      return true;
    }
    if (!Utils.isNullOrUndefined(this.meal2)){
      return true;
    }
    if (!Utils.isNullOrUndefined(this.break1)){
      return true;
    }
    if (!Utils.isNullOrUndefined(this.break2)){
      return true;
    }
    if (!Utils.isNullOrUndefined(this.note)){
      return true;
    }
    if (!Utils.isNullOrUndefined(this.function)){
      return true;
    }
    if (!Utils.isNullOrUndefined(this.task1)){
      return true;
    }
    if (!Utils.isNullOrUndefined(this.task2)){
      return true;
    }
    if (!Utils.isNullOrUndefined(this.task3)){
      return true;
    }
    if (!Utils.isNullOrUndefined(this.task4)){
      return true;
    }
    if (!Utils.isNullOrUndefined(this.task5)){
      return true;
    }
    if (!Utils.isNullOrUndefined(this.task6)){
      return true;
    }
    if (!Utils.isNullOrUndefined(this.task7)){
      return true;
    }
    if (!Utils.isNullOrUndefined(this.task8)){
      return true;
    }
    if (!Utils.isNullOrUndefined(this.task9)){
      return true;
    }
    if (!Utils.isNullOrUndefined(this.task10)){
      return true;
    }

    return false;
  }

  public get hasColor(): boolean{
      if ((!Utils.isNullOrUndefined(this.sdDefaultBg)) && (this.sdDefaultBg!==0)){
          return true;
      }
      return false;
  }


  get toHexColor(): string{
    if ((!Utils.isNullOrUndefined(this.sdDefaultBg)) && (this.sdDefaultBg!==0)){
      let hexColor = Utils.decimalToHexColor(this.sdDefaultBg);
      // console.log('Color Bg EmployeeSchedule: ' + this.sdDefaultBg + ' hex: ' + hexColor);
      return hexColor;
    }else{
      return 'transparent';
    }
  }


  addEmployeeTimedTaskParams(bean: EmployeeTimedTaskParams):boolean{
      let res = false;
      if (!this.timedTasksParams){
        this.timedTasksParams = new Array<EmployeeTimedTaskParams>();
      }
      for (const tmp of this.timedTasksParams){
        if (tmp.id === bean.id){
          res = true;
        }
      }
      if (res===false){
        //Not Found
        this.timedTasksParams.push(bean);
      }

      return !res;
  }


  /*
      const color = schedule.sdDefaultBg;
    if ((!Utils.isNullOrUndefined(color)) && (color!==0)){
      const hexColor = Utils.decimalToHexColor(color);
//      console.log('Schedule[0].color: ' + color + ' ' + hexColor);
      return this.domSanitizer.bypassSecurityTrustStyle('#' + hexColor);

   */



  public static sortSchedules(all: EmployeeSchedule[]): EmployeeSchedule[]{
    if (Utils.isNullOrUndefined(all)){
      return new Array<EmployeeSchedule>();
    }
    all.sort( (a: EmployeeSchedule, b: EmployeeSchedule) =>  {
      let resN = 0;
      if (Utils.isAfterRefDate(a.startHour,b.startHour)) {
        resN = 1;
      }
      if (!Utils.isAfterRefDate(a.startHour,b.startHour)) {
        resN = -1;
      }
      return resN;
    });
    return all;
  }


}


export class EmployeeInfo extends Cloneable {
  id: string;
  fname: string;
  fnamePreferred: string;
  lname: string;
  employeeImage: string;
  sex: SexType;

  visible = true;
  accessible = true;

  bdate = new Date();

  // Might be present
  wage = 0;
  email: string;
  professionalEmail: string;
  canBeNotifiedOnTheApplication = false;

  constructor () {
     super();
  }


  _createSpecialElement(propertyName: string, data: any) {
    if ('sex' === propertyName) {
      this.sex = SexType.retrieveFromCode(data);
      return true;
    }
    return false;
  }

  get lastNameFirstLetterFirstName(): string{
    return this._cutName(5,1);
  }

  get shortName(): string {
    return this._cutName(7,1);
  }


  get fullNameForTimesheet(): string{
    return this._cutName(10,1);
  }


  get fullNameForSchedule(): string{
    return this._cutName(9,1);
  }

  get fullNameForScheduleNoPicture(): string{
    return this._cutName(10,6);
  }




  private _cutName(maxLNameSize:number, maxFNameSize){
    let res = '';
    if (!Utils.isNullOrUndefined(this.lname)){
      if (this.lname.length>maxLNameSize){
        res += this.lname.substr(0,maxLNameSize) + '. ';
      }else{
        res = this.lname + ' ';
      }
    }
    if (!Utils.isNullOrUndefined(this.fnamePreferred)){
      if (this.fnamePreferred.length>maxFNameSize){
        res += this.fnamePreferred.substr(0,maxFNameSize) + '.';
      }else{
        res += this.fnamePreferred;
      }
    }else{
      if (!Utils.isNullOrUndefined(this.fname)){
        if (this.fname.length>maxFNameSize){
          res += this.fname.substr(0,maxFNameSize) + '.';
        }else{
          res += this.fname;
        }
      }
    }
    return res;

  }



  get fullName(): string {
    // console.log(' ' + this.fname + ' ' + this.lname);
    let prenom = this.fname;
    if (!Utils.isEmpty(this.fnamePreferred)){
      prenom = this.fnamePreferred;
    }
    if ( !prenom ) {
      if ( this.lname ) {
        return this.lname;
      }else {
        return '';
      }
    }
    if (!this.lname) {
        return prenom;
    }
    return this.lname + ' ' + prenom;
  }

}


export class JobUnitAndEmployee{
  jobId: string;
  unitId: string;
  employeeId: string;
  wage: number;
  jobBonus: number;
  level:number; // aka echelon
  bg: number;
  defaultJob = false;
  active = true;

  get hasColor(): boolean{
    if (!Utils.isNullOrUndefined(this.bg)){
      if (this.bg!==0){
        return true;
      }
    }
    return false;
  }

  get toHexColor(): string{
      if (this.bg === 0){
        return 'transparent';
      }
      let hexColor = Utils.decimalToHexColor(this.bg);
      // console.log('Color Bg jobAndUnitEmployee: ' + this.bg + ' hex: ' + hexColor);
      return hexColor;
  }

  get keyJobUnit(): string {
    return JobUnitAndEmployee.createKeyJobUnit(this.jobId,this.unitId);
  }

  get key(): string {
    return JobUnitAndEmployee.createKey(this.jobId,this.unitId,this.employeeId);
  }

  static createKey(jobId: string, unitId: string, employeeId: string) {
   return Utils.createKeyJobUnitEmployee(jobId,unitId,employeeId);
  }

  static createKeyJobUnit(jobId: string, unitId: string) {
    return Utils.createKeyJobUnit(jobId,unitId);
  }

}

export class EmployeeAndWage {
  employee: EmployeeInfo;
  wage: number;
}

export class EmployeeForScheduling {
  employee: EmployeeInfo = new EmployeeInfo();
  wage: number;
  level: number;
  seniority: number;
  availabilities = new Array<AvailabilityForASpecificDay>();
  schedules = new Array<EmployeeSchedule>();


  _createFromArray(propertyName: string, data: any) {
    const serializer = new JSonSerializer();
    if ('availabilities' === propertyName) {
      for (const bean of <AvailabilityForASpecificDay[]> data) {
        const tmp = new AvailabilityForASpecificDay();
        serializer.deserialize(bean, tmp);
        this.availabilities.push(tmp);
      }
    }
    if ('schedules' === propertyName) {
      for (const bean of <EmployeeSchedule[]> data) {
        const tmp = new EmployeeSchedule();
        serializer.deserialize(bean, tmp);
        this.schedules.push(tmp);
      }
    }
  }

  availabilityPerDayType(dt: DayType){
    for (const bean of this.availabilities){
      if (dt === bean.dayType){
        return bean;
      }
    }
    // console.log('Can\'t find the availability for ' + dt);
    return null;
  }


  schedulesPerDayType(dt: Date){
    const res = new Array<EmployeeSchedule>();
    for (const bean of this.schedules){
      if (Utils.sameDay(dt,bean.refDate)){
        res.push(bean);
      }
    }
    return res;
  }

}



export class AvailabilityForASpecificDay {
  refDate: Date;
  dayType: DayType;
  hoursNotAvailable = new Array<Date>();


  _createSpecialElement(propertyName: string, data: any) {
    if ('dayType' === propertyName) {
      this.dayType = DayType.retrieveFromCode(data);
      return true;
    }
    return false;
  }


  _createFromArray(propertyName: string, data: any) {
    const serializer = new JSonSerializer();
    if ('hoursNotAvailable' === propertyName) {
      for (const bean of <Date[]> data) {
        // const tmp = new AvailabilityForASpecificDay();
        // serializer.deserialize(bean, tmp);
        this.hoursNotAvailable.push(bean);
      }
    }
  }


}
  /*

    @Expose
    @SerializedName(value="refDate")
    Date m_date;

    @Expose
    @SerializedName(value="dayType")
    DayType m_dayType;

    @Expose
    @SerializedName(value="hoursNotAvailable")
    List<Date> m_HoursNotAvailable;


//    @Expose
    @SerializedName(value="availables")
    long[] m_Availables;

//    @Expose
    @SerializedName(value="notAvailables")
    long[] m_NotAvailables;



//    @Expose
    @SerializedName(value="availabilityRatio")
    Double m_AvailabilityRatio;

   */




/*
 "id": 4,
 "planningId": 3,
 "qty": 3,
 "jobId": "PR14_COMMIS DE BUREAUcc5b9",
 "day": "MONDAY",
 "interval": 17179344896,
 "jobLabel": "/Pharmafiles/Administration/Commis de bureau"
 */

